import { ComponentPortal } from '@angular/cdk/portal';
import { Component, HostListener, Injectable, Injector, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { ErrorManagerService } from '~/services/error-manager';
import { SharedService } from '~/services/sharedService';
import { PageState } from '~/shared/enums/stock-files.enum';
import { popupComponent } from '../popup/popup.component';
import { LayoutManagerService, PORTAL_DATA } from './layout-manager';

@Component({
    selector: 'asap-layout',
    templateUrl: './layout.html',
    styleUrls: ['./layout.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'asap-layout' },
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

@Injectable({
  providedIn: 'root'
})
export class LayoutComponent {
  _portal: ComponentPortal<any>;
  _popupPortal: ComponentPortal<any>;
  _isOverlay: boolean;
  _isPopupOverlay: boolean;
  _isDialiog: boolean;
  _dialogComponentName: string;
  _dialogModel: any;

  constructor(private injector: Injector,
    private _layoutManager: LayoutManagerService,
    private _errorManagerService: ErrorManagerService,
    private _sharedService: SharedService) {
    this._layoutManager.overlayChange.subscribe((x) => this.overlayChange(x));
    this._layoutManager.removePopup.subscribe((x) => this.detachPopup());

    this._errorManagerService.errorChange.subscribe((x) => {
      if (x) {
        this.openPopup(x);
      }
    });

    this._sharedService.openDialog.subscribe((result: any) => {
      this.openUpsert(result.componentName, result.model, result.pageState);
    });
  }

  openUpsert(componentName: string, model: any, pageState: PageState) {
    this._dialogComponentName = componentName;
    this._dialogModel = { model, pageState };
    this._isDialiog = true;
  }

  _closeDialog(event: any) {
    if (typeof event === 'boolean') {
      this._isDialiog = event;
    } else if (event && typeof event.open === 'boolean') {
      this._isDialiog = event.open;
    } else if (event && event.isClosed) {
      this._isDialiog = false;
    } else {
      this._isDialiog = false;
    }
  }

  @HostListener('document:click', ['$event'])
  documentClick(event: MouseEvent) {
    this._layoutManager.setPageClick(event);
  }

  //#region  openDialogForm
  openDialogForm(component: any, pageState: PageState = PageState.VIEW, model?: any) {
    this.detachDialogForm();
    const isNew = !model;
    let paramObject = model ? model : new Object();
    this._portal = new ComponentPortal(component, null, this.createInjector({ model: paramObject, pageState, isNew }));
  }

  //#endregion
  detachDialogForm() {
    if (this._portal && this._portal.isAttached) {
      this._portal.detach();
    }
  }

  openPopupDialogForm(component: any, pageState: PageState = PageState.VIEW, model?: any) {
    const isNew = !model;
    let paramObject = model ? model : new Object();
    this._popupPortal = new ComponentPortal(component, null, this.createInjector({ model: paramObject, pageState, isNew }));
    //this._isPopupOverlay = true;
  }

  openPopup(data: any) {
    this._popupPortal = new ComponentPortal(popupComponent, null, this.createInjector({ model: data }));
    this._isPopupOverlay = true;
  }

  detachPopup() {
    if (this._popupPortal && this._popupPortal.isAttached) {
      this._popupPortal?.detach();
    }

    this._isPopupOverlay = false;
  }

  private async overlayChange(apply: boolean) {
    await this.delay(5);

    this._isOverlay = apply;
    document.body.style.overflow = apply ? 'hidden' : '';
    document.body.style.position = apply ? 'fixed' : '';
  }

  private createInjector(data: any) {
    return Injector.create({
      parent: this.injector,
      providers: [{ provide: PORTAL_DATA, useValue: data }]
    });


  }

  delay(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
}
